import React, { Component } from 'react';
import { Wrapper, Container, Heading, Reason, ReasonNo, ReasonText } from './styles';
import Testimonials from './Testimonials';

class Feedback extends Component {
  render() {
    return (
      <>
        <Wrapper>
          <Container>
            <Heading>Why attend SJT Preparation?</Heading>
            <Reason>
              <ReasonNo>1</ReasonNo>
              <ReasonText>
                SJT Preparation is the most popular SJT course provider. Not only do more students attend our course
                than any other course, but they also achieve exceptional results.
              </ReasonText>
            </Reason>
            <Reason>
              <ReasonNo>2</ReasonNo>
              <ReasonText>
                Our students consistently score high above the national average. We obtain verifiable results which
                prove that year upon year those who attend strengthen their position in the national rankings.
              </ReasonText>
            </Reason>
            <Reason>
              <ReasonNo>3</ReasonNo>
              <ReasonText>
                We rely on a team of consultants rather than one or two individuals. Every year our team conducts an
                in-depth review to ensure that course content is maximised to ensure your success.
              </ReasonText>
            </Reason>
          </Container>
        </Wrapper>
        <Testimonials />
      </>
    );
  }
}

export default Feedback;
